import React from 'react';
import { Container, Header, Image } from 'semantic-ui-react';

import marketplaceImage from '../../../images/grafix-banner/Marketplace.svg';

const MarketPlace = () => (
  <Container className="demoImage">
    <Header as='h2' icon textAlign='center'>
      <Header.Content>
        Marketplace
          </Header.Content>
    </Header>
    <Image src={marketplaceImage} size='large' centered={true} />
  </Container>
);

export default MarketPlace;